import { createFileRoute, redirect } from '@tanstack/react-router'
import { RegisterPage } from '@/pages/auth/register/RegisterPage'
import { BaseAuthSearchSchema } from '@/schemas/page'

export const Route = createFileRoute('/auth/register')({
  validateSearch: BaseAuthSearchSchema,
  beforeLoad: ({ context, search }) => {
    if (context.authContext.isAuthenticated) {
      return redirect({
        to: search.redirect ?? '/home',
      })
    }
  },
  component: RegisterPage,
})
